import React, { useEffect, useState } from 'react';
import { fetchCoverSampleHtml, fetchCoverPreviewHtml } from '../../services/compositionApi';

// LIVRE DESSINE AVEC SA VRAIE COUVERTURE (phase 9, docs/atelier-formats.html).
//
// La couverture est rendue par le MEME code que celle de l'atelier et du fichier d'impression (serveur :
// GET /api/catalog/cover-sample.html), avec un titre d'exemple : l'apercu et le livre commande ne peuvent pas
// diverger. Tous les livres sont a la MEME ECHELLE (1 cm = 9 px, voir .fbk dans CreateBookSansIA.css) et posés sur
// une meme etagere : le Livret 20 x 20 est visiblement carre et plus petit, le Standard et le Luxe (21 x 28) ont la
// meme taille. Couverture souple : charniere fine, tranche mince. Rigide : plateau qui depasse, rainure, reflet,
// tranche plus epaisse.
const htmlCache = new Map();

function FormatBook({ formatId, widthMm, heightMm, reliure, style, lang, alt, ownBookId = null }) {
  const key = `${ownBookId || 'sample'}|${formatId}|${style}|${lang}`;
  const [html, setHtml] = useState(() => htmlCache.get(key) || null);

  useEffect(() => {
    let cancelled = false;
    const cached = htmlCache.get(key);
    if (cached) { setHtml(cached); return undefined; }
    // Connecte avec un livre qui a deja une photo : SA derniere couverture, montree dans chaque format ; sinon (ou si
    // elle ne se charge pas) la couverture d'exemple.
    const sample = () => fetchCoverSampleHtml({ format: formatId, style, lang });
    const load = () => (ownBookId
      ? fetchCoverPreviewHtml(ownBookId, 'front', { format: formatId, style }).catch(sample)
      : sample());
    load()
      .then((text) => { htmlCache.set(key, text); if (!cancelled) setHtml(text); })
      .catch(() => { /* non bloquant : le livre reste dessine, sans couverture */ });
    return () => { cancelled = true; };
  }, [key, formatId, style, lang]);

  const cw = Number(widthMm) / 10 || 21;
  const ch = Number(heightMm) / 10 || 28;
  return (
    <div
      className={`fbk ${reliure === 'rigide' ? 'is-hard' : ''}`}
      style={{ '--cw': cw, '--ch': ch }}
      role="img"
      aria-label={alt}
    >
      <div className="fbk-pages" />
      <div className="fbk-cover">
        {html ? <iframe title={alt} srcDoc={html} tabIndex={-1} aria-hidden="true" /> : <span className="fbk-skeleton" />}
      </div>
    </div>
  );
}

export default FormatBook;
